var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-header"},[_c('img',{staticClass:"company-logo",attrs:{"src":_vm.getState.theme.logo.url,"alt":_vm.getState.theme.logo.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }